// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"295f0fb5","453":"201a1bba","455":"96dec25f"}[chunkId] + ".chunk.js";
};